import { FormFieldsStrategyType, QuotesType } from "@/common/types";
import diaQuoteLineFormStrategy from "./diaQuoteLineForm.strategy";
import biqQuoteLineFormStrategy from "./biqQuoteLineForm.strategy";
import wiaQuoteLineFormStrategy from "./wiaQuoteLineForm.strategy";
import ipAddressQuoteLineFormStrategy from "./ipAddressQuoteLineForm.strategy";
import eplQuoteLineFormStrategy from "./eplQuoteLineForm.strategy";
import hardwareQuoteLineFormStrategy from "./hardwareQuoteLineForm.strategy";
import fieldServiceQuoteLineStrategy from "./fieldServiceQuoteLine.strategy";
import rackAndSpaceQuoteLineFormStrategy from "./rackAndSpaceQuoteLineForm.strategy";
import crossConnectQuoteLineFormStrategy from "./crossConnectQuoteLineForm.strategy";
import { QUOTES_TYPE } from "@/common/const/types/index.const";

const customerQuoteLineStrategy: Record<QuotesType, FormFieldsStrategyType[]> =
  {
    [QUOTES_TYPE[0]]: diaQuoteLineFormStrategy,
    [QUOTES_TYPE[1]]: diaQuoteLineFormStrategy,
    [QUOTES_TYPE[2]]: biqQuoteLineFormStrategy,
    [QUOTES_TYPE[3]]: wiaQuoteLineFormStrategy,
    [QUOTES_TYPE[4]]: ipAddressQuoteLineFormStrategy,
    [QUOTES_TYPE[5]]: eplQuoteLineFormStrategy,
    [QUOTES_TYPE[6]]: eplQuoteLineFormStrategy,
    [QUOTES_TYPE[7]]: hardwareQuoteLineFormStrategy,
    [QUOTES_TYPE[8]]: fieldServiceQuoteLineStrategy,
    [QUOTES_TYPE[9]]: rackAndSpaceQuoteLineFormStrategy,
    [QUOTES_TYPE[10]]: crossConnectQuoteLineFormStrategy,
  };
export default customerQuoteLineStrategy;
